import {Button} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import {Email, isValidEmail, ValidEmail} from 'Core/models/Email';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import EmailInput from 'Shared/components/EmailInput';

export type UsernameRecoveryFormProps = {
  email: Email;
  onSubmit: (email: ValidEmail) => void;
  onChangeEmail: (email: Email) => void;
};

const UsernameRecoveryForm = (props: UsernameRecoveryFormProps) => {
  const valid = useSelector((state: ReducerState) => state.user.userRecovery.valid);

  return (
    <div className="username-recovery__form">
      <h1>Recover Username</h1>
      <p className="username-recovery__description">
        Please enter the email address used during registration to recover your username.
      </p>
      <EmailInput
        email={props.email}
        onChange={props.onChangeEmail}
        className="username-recovery__email-input"
        variant="outlined"
        label="Email Address"
      />
      {!valid && (
        <div>
          <Alert severity="error">Incorrect email. Please try again</Alert>
          <br />
        </div>
      )}
      <Button
        onClick={() => isValidEmail(props.email) && props.onSubmit(props.email)}
        disabled={!isValidEmail(props.email)}
        variant="contained"
        color="primary"
        className="username-recovery__submit"
      >
        Submit
      </Button>
    </div>
  );
};

export default UsernameRecoveryForm;
